import ReactOnRails from 'react-on-rails';
import { App } from '@root/app/react/App';
import { configureStore } from '@app/react/store';

const orderMadeStore = configureStore;

ReactOnRails.registerStore({ orderMadeStore });
ReactOnRails.register({ App });
